export default function restrictKeys(): void {
  document.addEventListener("keydown", (event): void => {
    if (event.key === "Tab" && !event.target?.closest("[data-focus-lock-disabled='false']")) {
      event.preventDefault();
      event.stopPropagation();
    } else if (event.key === "`") {
      event.preventDefault();
      event.stopPropagation();
    }
  });
}
